import { render, staticRenderFns } from "./skiniver-list.vue?vue&type=template&id=2aab7272&scoped=true&"
import script from "./skiniver-list.vue?vue&type=script&lang=js&"
export * from "./skiniver-list.vue?vue&type=script&lang=js&"
import style0 from "./skiniver-list.vue?vue&type=style&index=0&id=2aab7272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab7272",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
